/* ============================================================
   Leaves Lighting — Configurator catalog + pricing helpers
   All fixtures 3000K warm white · 24V DC · IP65 outdoor-rated.
   Each item carries `handle` so build lines link to its PDP.
   Same `group` = one card with a size/colour picker.
   Card names/photos editable via theme editor blocks; displayed
   prices override live from Shopify products (window.LV_PRICES).
   ============================================================ */

const PR = 'assets/products/';

const CFG_SYSTEMS = {
  cb: { id:'cb', name:'Color Bridge', code:'DGX', image: SCENES.cbFamily, trackImg: PR+'cable-black.jpg', desc:'Hand-bendable silicone wire you shape by hand, then clip fixtures straight on.', callouts:['Hand-bendable', 'IP65 outdoor', '6 cable colours'], trackName:'Color Bridge wire' },
  lnt: { id:'lnt', name:'LNT Track', code:'ZCHW', image: SCENES.lntFamily, trackImg: PR+'rail-zchw.png', desc:'Rigid moulded-polymer rail — the Color Bridge wire lays inside the channel for clean architectural runs.', callouts:['Polymer rail', 'Architectural', 'Wire lays inside'], trackName:'LNT Track' },
};

const CB_SEG_FT = 15;
const CB_SEG_PRICE = 33;
const CB_MAX_FT = 30;
const LNT_SECTION_FT = 4;
const LNT_SECTION_PRICE = 9;
const LNT_MAX_SECTIONS = 20;
const CB_WIRE_IMG = PR+'cable-black.jpg';
const CB_WIRE_URL = '/products/color-bridge-wire';
const CB_WIRE_IMG_BY_COLOR = { black: PR+'wire-black.jpg', red: PR+'wire-red.png', yellow: PR+'wire-yellow.png', blue: PR+'wire-blue.png', green: PR+'wire-green.jpg', gray: PR+'wire-gray.png' };
function cbWireImg(color){ return CB_WIRE_IMG_BY_COLOR[(color||'black').toLowerCase()] || CB_WIRE_IMG; }
const LNT_RAIL_URL = '/products/lnt-track-rail';
const RUN_MAX_W = 72;   // a single run uses ONE driver; biggest driver is 72W

const SPACES = [
  { id:'pergola', name:'Pergola',     img:SCENES.sPergola, hint:'Overhead globes & linear bars', length:30, suggest:{ cb:['cb-globe','cb-linear'], lnt:['lnt-down','lnt-dual'] } },
  { id:'balcony', name:'Balcony',     img:SCENES.balcony, hint:'Vertical light along the rail',  length:15, suggest:{ cb:['cb-globe','cb-pendant'], lnt:['lnt-cyl'] } },
  { id:'garden',  name:'Garden Path', img:SCENES.garden,  hint:'Low globes & ground spots',       length:30, suggest:{ cb:['cb-globe','cb-spot'], lnt:['lnt-narrow'] } },
  { id:'wall',    name:'Wall',        img:SCENES.sWallSpots,    hint:'Spots & wall washes',             length:15, suggest:{ cb:['cb-spot','cb-wash'], lnt:['lnt-washer'] } },
  { id:'umbrella',name:'Umbrella',    img:'https://cdn.shopify.com/s/files/1/0754/8328/3635/files/Umbrella-Kit_8514492956851.jpg', hint:'Bell lantern over a table',        length:15, suggest:{ cb:['cb-pendant','cb-globe'], lnt:['lnt-down'] } },
  { id:'indoor',  name:'Indoor',      img:SCENES.dining,  hint:'Warm pendants over a table',      length:15, suggest:{ cb:['cb-pendant','cb-globe'], lnt:['lnt-down'] } },
];

const LANTERNS = [
  { id:'cb-lantern-round',  group:'lantern', gname:'Decorative Lantern', vlabel:'Round',  name:'Round Lantern',  model:'CQA-PC-D150-5.5W',  photo:PR+'lantern-round.jpg',  watt:5.5, lumens:245, price:76, handle:'round-decorative-lantern' },
  { id:'cb-lantern-square', group:'lantern', gname:'Decorative Lantern', vlabel:'Square', name:'Square Lantern', model:'CQA-PC-F009-5.5W',  photo:PR+'lantern-curved.jpg', watt:5.5, lumens:245, price:89, handle:'square-decorative-lantern' },
  { id:'cb-lantern-bell',   group:'lantern', gname:'Decorative Lantern', vlabel:'Bell',   name:'Bell Lantern',   model:'CQA-PC-FB220-5.5W', photo:'https://cdn.shopify.com/s/files/1/0754/8328/3635/files/BellDecorativeLantern_8514492399795.jpg',   watt:5.5, lumens:245, price:98, handle:'bell-decorative-lantern' },
];

const FIXTURES = {
  cb: [
    { id:'cb-globe-sm', group:'globe', gname:'Globe Light', vlabel:'120mm · 5W', name:'Globe Light — 120mm', model:'CQA-HW-YQYKL12-5W', photo:PR+'globe-sm.png', watt:5, lumens:370, price:49, handle:'globe-light' },
    { id:'cb-globe',    group:'globe', gname:'Globe Light', vlabel:'154mm · 5W', name:'Globe Light — 154mm', model:'CQA-HW-YQYKL15-5W', photo:PR+'globe-md.jpg', watt:5, lumens:400, price:51, handle:'globe-light', vdefault:true },
    { id:'cb-globe-lg', group:'globe', gname:'Globe Light', vlabel:'197mm · 7W', name:'Globe Light — 197mm', model:'CQA-HW-YQYKL20-7W', photo:PR+'globe.jpg', watt:7, lumens:500, price:59, handle:'globe-light' },
    { id:'cb-linear',  group:'linear', gname:'Linear Tube Light', vlabel:'1.5 m · 14W', name:'Linear Tube Light — 1.5 m', model:'CQA-HW-G18-150-14W', photo:PR+'globe-14w.png', watt:14, lumens:800, price:73, handle:'linear-tube-light', vdefault:true },
    { id:'cb-linear3', group:'linear', gname:'Linear Tube Light', vlabel:'3 m · 27W', name:'Linear Tube Light — 3 m', model:'CQA-HW-G18-300-27W', photo:PR+'globe-14w.png', watt:27, lumens:1550, price:124, handle:'linear-tube-light' },
    { id:'cb-spot',    name:'Spot Pendant',       model:'CQA-SZ-10W',     photo:PR+'spot-sz-pic.png',   watt:10, lumens:750, price:44, handle:'spot-pendant' },
    { id:'cb-pendant',   group:'bell', gname:'Bell Pendant', vlabel:'Black', name:'Bell Pendant — Black', model:'CQA-BJW-C-01',   photo:'https://cdn.shopify.com/s/files/1/0754/8328/3635/files/BellPendant-BLACK-XBJW_8514492203187.jpg', watt:12, lumens:840, price:65, handle:'bell-pendant', vdefault:true },
    { id:'cb-pendant-w', group:'bell', gname:'Bell Pendant', vlabel:'White', name:'Bell Pendant — White', model:'CQA-BJW-C-01-W', photo:PR+'bell-cb-white.jpg', watt:12, lumens:840, price:65, handle:'bell-pendant' },
    { id:'cb-wash',    name:'XMY Pendant',        model:'CQA-XMY-12W',    photo:'https://cdn.shopify.com/s/files/1/0754/8328/3635/files/XMY-Pendant_8514492301491.jpg',        watt:12, lumens:760, price:48, handle:'xmy-pendant' },
    { id:'cb-strip',   name:'LED Linear Strip',   model:'CQ-RXXTD-15W',   photo:'https://cdn.shopify.com/s/files/1/0754/8328/3635/files/LED-Strip_8514492235955.jpg', watt:15, lumens:1000, price:48, handle:'led-linear-strip' },
    ...LANTERNS,
  ],
  lnt: [
    { id:'lnt-down',   name:'LNT Downlight',      model:'LNT-DT-12W',  photo:PR+'lnt-dt-pic.png', watt:12, lumens:830, price:74, handle:'lnt-downlight' },
    { id:'lnt-dual',   name:'LNT Dual Spot',      model:'LNT-ST-7W×2', photo:PR+'lnt-st.png',     watt:14, lumens:850, price:75, handle:'lnt-dual-spot' },
    { id:'lnt-narrow', name:'LNT XMY Pendant',    model:'LNT-XMY-12W', photo:'https://cdn.shopify.com/s/files/1/0754/8328/3635/files/LNT-XMY_8514492563635.jpg',    watt:12, lumens:760, price:48, handle:'lnt-xmy-pendant' },
    { id:'lnt-washer', name:'LNT Spot',           model:'LNT-SZ-10W',  photo:'https://cdn.shopify.com/s/files/1/0754/8328/3635/files/LNT-Spot_8514492530867.jpg',     watt:10, lumens:700, price:54, handle:'lnt-spot' },
    { id:'lnt-cyl',   group:'lnt-bell', gname:'LNT Bell Pendant', vlabel:'Black', name:'LNT Bell Pendant — Black', model:'LNT-BJW-C-01',   photo:'https://cdn.shopify.com/s/files/1/0754/8328/3635/files/LNT-Bell-XBJW_8514492596403.jpg', watt:12, lumens:620, price:74, handle:'lnt-bell-pendant', vdefault:true },
    { id:'lnt-cyl-w', group:'lnt-bell', gname:'LNT Bell Pendant', vlabel:'White', name:'LNT Bell Pendant — White', model:'LNT-BJW-C-01-W', photo:'https://cdn.shopify.com/s/files/1/0754/8328/3635/files/LNT-Bell-WHITE_8514492596403.jpg', watt:12, lumens:620, price:74, handle:'lnt-bell-pendant' },
    ...LANTERNS,
  ],
};
const FIXTURE_BY_ID = {};
Object.values(FIXTURES).flat().forEach(f => { FIXTURE_BY_ID[f.id] = f; });

/* Kit -> editable components + the kit's fixed driver (its sealed single-run power). */
const KIT_COMPONENTS = {
  'kit-pathway':     { system:'cb',  length:15, sections:4, driver:36, fixtures:{ 'cb-globe':2, 'cb-globe-lg':1 } },
  'kit-pathway-ext': { system:'cb',  length:30, sections:8, driver:72, fixtures:{ 'cb-globe':2, 'cb-globe-lg':1, 'cb-linear':2 } },
  'kit-contour':     { system:'cb',  length:30, sections:8, driver:72, fixtures:{ 'cb-linear3':2 } },
  'kit-umbrella':    { system:'lnt', length:15, sections:4, driver:36, fixtures:{ 'cb-lantern-bell':1, 'lnt-down':1 } },
};
const KIT_HANDLE = { 'kit-pathway':'kit-pathway', 'kit-pathway-ext':'kit-pathway-extended', 'kit-contour':'kit-contour-tree', 'kit-umbrella':'kit-umbrella' };

const DRIVERS = {
  36: { cap:36, name:'Waterproof Driver 36W', model:'36LZ', photo:PR+'driver-36lz.jpg', price:29, handle:'waterproof-driver' },
  72: { cap:72, name:'Waterproof Driver 72W', model:'72LZ', photo:PR+'driver-72lz.jpg', price:40, handle:'waterproof-driver' },
};

const ENDCAPS   = { name:'End caps (pair)', model:'DC001', photo:PR+'acc-dc001-pic.png', price:1, handle:'end-caps' };
const CLIP      = { name:'LNT Track fixing clips', model:'TS15-DT', photo:PR+'acc-ts15.png', price:2, handle:'lnt-track-fixing-clip' };
const GDJ       = { name:'GDJ anchors', model:'GDJ', photo:PR+'acc-gdj.png', price:3, handle:'gdj-anchor' };

/* ---- Theme-editor overrides (blocks) + live Shopify prices ---- */
(function () {
  var C = window.LV_CHROME || {};
  var SO = C.spaces || {}, YO = C.systems || {};
  SPACES.forEach(function (sp) { var o = SO[sp.id]; if (!o) return; if (o.name) sp.name = o.name; if (o.hint) sp.hint = o.hint; if (o.photo) sp.img = o.photo; });
  Object.keys(CFG_SYSTEMS).forEach(function (k) { var sys = CFG_SYSTEMS[k], o = YO[sys.id]; if (!o) return; if (o.name) sys.name = o.name; if (o.desc) sys.desc = o.desc; if (o.photo) sys.image = o.photo; });
  var LP = window.LV_PRICES || {};
  var ALIAS = { 'CQA-BJW-C-01': 'CQA-BJW-C-01-B', 'LNT-BJW-C-01': 'LNT-BJW-C-01-B' };
  var priceOf = function (model) { if (!model) return null; var k = String(model).replace(/×/g, 'x'); k = ALIAS[k] || k; return LP[k] || null; };
  Object.values(FIXTURES).flat().forEach(function (f) { var p = priceOf(f.model); if (p) f.price = p; });
  [DRIVERS[36], DRIVERS[72], ENDCAPS, CLIP, GDJ].forEach(function (x) { var p = priceOf(x.model); if (p) x.price = p; });
})();

const SUG_ACCESSORIES = [
  { id:'sug-endcaps', name:'Spare end caps', photo:PR+'acc-dc001-pic.png', price:12, note:'Keep a sealed spare', model:'DC001', mult:1, handle:'end-caps' },
  { id:'sug-clips',   name:'Extra GDJ anchors ×8', photo:PR+'acc-gdj.png', price:36, note:'For tighter spans', model:'GDJ', mult:8, handle:'gdj-anchor' },
];
function fixtureSuggestions(system) {
  const pool = system === 'lnt' ? FIXTURES.lnt : FIXTURES.cb;
  return pool.map(f => ({ id:'fx-sug-'+f.id, name:f.name, photo:f.photo, price:f.price, note:f.watt+'W · '+f.lumens+' lm warm', model:f.model, mult:1, handle:f.handle }));
}
const EXTRAS_BY_ID = {};
SUG_ACCESSORIES.forEach(s => { EXTRAS_BY_ID[s.id] = s; });
Object.values(FIXTURES).flat().forEach(f => {
  EXTRAS_BY_ID['fx-sug-'+f.id] = { id:'fx-sug-'+f.id, name:f.name, photo:f.photo, price:f.price, note:f.watt+'W · '+f.lumens+' lm warm', model:f.model, mult:1, handle:f.handle };
});
function suggestionsFor(state) {
  const sys = state && state.system ? state.system : 'cb';
  const fix = fixtureSuggestions(sys).filter(s => {
    const fid = s.id.replace('fx-sug-','');
    return !(state && state.fixtures && state.fixtures[fid] > 0);
  }).slice(0, 4);
  return [...fix, ...SUG_ACCESSORIES];
}
const SUGGESTIONS = SUG_ACCESSORIES;

const FREE_SHIP = 300;
const TAX_RATE = 0.08;

function fixtureWatts(fixtures) {
  return Object.entries(fixtures).reduce((s,[id,q]) => s + (FIXTURE_BY_ID[id] ? FIXTURE_BY_ID[id].watt * q : 0), 0);
}
/* watts from review-step extras that are fixtures (fx-sug-<id>) */
function extrasWatts(extras) {
  let w = 0;
  for (const id in (extras || {})) { const m = /^fx-sug-(.+)$/.exec(id); if (m && FIXTURE_BY_ID[m[1]]) w += FIXTURE_BY_ID[m[1]].watt * extras[id]; }
  return w;
}
function driverCap(fixtures) { return fixtureWatts(fixtures) > 36 ? 72 : 36; }
function clipCount(ft) { return Math.max(2, Math.ceil(ft / 4)); }
function coverage(ft) { return Math.round(ft); }

function trackFt(state) {
  return state.system === 'lnt' ? (state.sections || 1) * LNT_SECTION_FT : (state.length || CB_SEG_FT);
}
function wireFt(state) {
  if (state.system === 'lnt') {
    const tft = (state.sections || 1) * LNT_SECTION_FT;
    return Math.max(CB_SEG_FT, Math.ceil(tft / CB_SEG_FT) * CB_SEG_FT);
  }
  return state.length || CB_SEG_FT;
}

function buildLines(state) {
  const lines = [];
  const sys = state.system ? CFG_SYSTEMS[state.system] : null;
  if (sys) {
    const cap = driverCap(state.fixtures);
    if (state.system === 'lnt') {
      const secs = state.sections || 1;
      const tft = secs * LNT_SECTION_FT;
      const wft = wireFt(state);
      lines.push({ key:'track', name:`LNT Track · ${secs} × 3 ft (${tft} ft)`, qty:1, unit:LNT_SECTION_PRICE*secs, photo:sys.trackImg, fixed:true, url:LNT_RAIL_URL });
      lines.push({ key:'wire', name:`Color Bridge wire · ${wft} ft (required)`, qty:1, unit:CB_SEG_PRICE*(wft/CB_SEG_FT), photo:CB_WIRE_IMG, fixed:true, url:CB_WIRE_URL });
      lines.push({ key:'driver', name:DRIVERS[cap].name, qty:1, unit:DRIVERS[cap].price, photo:DRIVERS[cap].photo, fixed:true, url:'/products/'+DRIVERS[cap].handle });
      lines.push({ key:'clips', name:CLIP.name, qty:clipCount(tft), unit:CLIP.price, photo:CLIP.photo, fixed:true, url:'/products/'+CLIP.handle });
      lines.push({ key:'endcaps', name:ENDCAPS.name, qty:1, unit:ENDCAPS.price, photo:ENDCAPS.photo, fixed:true, url:'/products/'+ENDCAPS.handle });
    } else {
      const len = state.length || CB_SEG_FT;
      if (!state.kit) {
        lines.push({ key:'track', name:`Color Bridge wire + driver · ${len} ft`, qty:1, unit:((state.length||15)>=30)?106:62, photo:cbWireImg(state.color), fixed:true, url:CB_WIRE_URL });
        lines.push({ key:'clips', name:GDJ.name, qty:clipCount(len), unit:GDJ.price, photo:GDJ.photo, fixed:true, url:'/products/'+GDJ.handle });
        lines.push({ key:'endcaps', name:ENDCAPS.name, qty:1, unit:ENDCAPS.price, photo:ENDCAPS.photo, fixed:true, url:'/products/'+ENDCAPS.handle });
      } else {
        lines.push({ key:'track', name:`Color Bridge wire · ${len} ft`, qty:1, unit:CB_SEG_PRICE*(len/CB_SEG_FT), photo:sys.trackImg, fixed:true, url:CB_WIRE_URL });
        lines.push({ key:'driver', name:DRIVERS[cap].name, qty:1, unit:DRIVERS[cap].price, photo:DRIVERS[cap].photo, fixed:true, url:'/products/'+DRIVERS[cap].handle });
        lines.push({ key:'clips', name:GDJ.name, qty:clipCount(len), unit:GDJ.price, photo:GDJ.photo, fixed:true, url:'/products/'+GDJ.handle });
        lines.push({ key:'endcaps', name:ENDCAPS.name, qty:1, unit:ENDCAPS.price, photo:ENDCAPS.photo, fixed:true, url:'/products/'+ENDCAPS.handle });
      }
    }
  }
  Object.entries(state.fixtures).forEach(([id,q]) => {
    const f = FIXTURE_BY_ID[id]; if (!f || q<=0) return;
    lines.push({ key:'fx-'+id, fxId:id, name:f.name, qty:q, unit:f.price, photo:f.photo, url: f.handle ? '/products/'+f.handle : undefined });
  });
  return lines;
}
function buildSubtotal(state) { return buildLines(state).reduce((s,l) => s + l.unit*l.qty, 0); }

Object.assign(window, {
  CFG_SYSTEMS, SPACES, FIXTURES, FIXTURE_BY_ID, DRIVERS, ENDCAPS, CLIP, GDJ, LANTERNS,
  KIT_COMPONENTS, KIT_HANDLE, RUN_MAX_W,
  SUGGESTIONS, SUG_ACCESSORIES, EXTRAS_BY_ID, fixtureSuggestions, suggestionsFor,
  FREE_SHIP, TAX_RATE, fixtureWatts, extrasWatts, driverCap, clipCount, coverage, buildLines, buildSubtotal,
  CB_SEG_FT, CB_SEG_PRICE, CB_MAX_FT, LNT_SECTION_FT, LNT_SECTION_PRICE, LNT_MAX_SECTIONS, trackFt, wireFt, cbWireImg, CB_WIRE_IMG_BY_COLOR,
});
